import BaseApiClient from '../BaseApiClient';

import TeamInterface from '@interfaces/Team.interface';

export class ApiTeams extends BaseApiClient {
  /**
   * Get a team
   */
  async get(teamId: number): Promise<TeamInterface> {
    return new Promise((resolve, reject) => {
      this.client
        .get(`/teams/${teamId}/members`)
        .then((res) => {
          if (res.data) {
            resolve(res.data);
          } else {
            reject('Invalid response');
          }
        })
        .catch((err) => reject(err));
    });
  }
}

export { teamsQueryKeys } from './query-keys';
export { useTeamQuery } from './use-teams-queries';

